export const STATUS_TYPES = {
  0: {
    label: '交易成功',
    value: 0
  },
  1: {
    label: '已审核',
    value: 1
  },
  2: {
    label: '确认中',
    value: 2
  },
  3: {
    label: '卖单待审批',
    value: 3
  },
  4: {
    label: '卖单审批通过',
    value: 4
  },
  5: {
    label: '审批不通过',
    value: -2
  },
  6: {
    label: '失败',
    value: -1
  },
};
export const PAGINATION = {
  page: 1,
  size: 25
};
